import React, { Component } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { isEmpty } from 'lodash';
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({accountsData}) {
    const { AvtalTyp,currentAccount } = accountsData;
    return {
        AvtalTyp,currentAccount
    };
}

class AvtalsTyp extends Component {
    state={
        avtaltype:0
    }
    getAvtalType=(e)=>{
        let Meta = this.props.isAvtal === 1?"Avtalstyp":"Prospekttyp"
        this.props.onChangeHandleMulti(Meta,e.target.value)        
    }
    render() {
        return (
            <div>
                <form>
                <div style={{ height: 'auto', paddingTop: '10px' }}>
                <TextField
                    select
                    label={ this.props.isAvtal === 1?<IntlMessages id="Agreement.Type"/>:"Prospekttyp"}
                    variant="outlined"
                    size="small"
                    value={this.state.avtaltype}
                    fullWidth
                    onChange={this.getAvtalType}
                    SelectProps={{
                        native: true,
                    }}
                >
                    <option Key="0" disabled  value={0}><IntlMessages id="Choose"/></option>
                    {this.props.AvtalTyp.map((option) => (
                        <option key={option.id} value={option.type}>
                            {option.type}
                        </option>
                    ))}
                </TextField>
            </div>
        </form>
            </div>
        );
    }
}

export default connect(
    mapStateToProps
)(AvtalsTyp);
